// oxlint-disable-next-line no-restricted-imports
import { createRoutePath } from "@myvp/shared/src/functions/create-route-path"

const routeNames = {
  version: createRoutePath("/version"),
  sponsorsRedirect: createRoutePath("/sponsors-redirect"),
  veevaLibrary: createRoutePath("/veevaLibrary"),
  veevaLibraryPreview: createRoutePath(
    "/veevaLibrary/preview/:surveyTemplateId"
  ),
  error: createRoutePath("/error"),
} as const

export default routeNames
